// @flow

//
// IMPORTS
//

// Styles
import gl from 'glamorous';
// import { css } from 'glamor';
/* eslint-disable no-unused-vars */
import { createElement } from 'glamor/react';
/* eslint-enable no-unused-vars */
import stSys from 'styled-system';
/* @jsx createElement */

// React
import React from 'react';
import PropTypes from 'prop-types';

// Files

// Components
import { theme as themeGbl } from './theme';

//
// COMPONENTS
//


// Theme
export { themeGbl as theme };

// Responsive properties (Allow array based values that are active by media-queries)

// height = h in rem units : Default val 1rem

export const Box = gl.div(
  stSys.space,
  stSys.width,
  stSys.fontSize,
  stSys.color,
  stSys.textAlign,
  stSys.flexWrap,
  stSys.borderColor,
  stSys.borderWidth,
  stSys.fontWeight,
  // Responsive for display
  stSys.responsiveStyle('display', 'display'),
  {
    position: 'relative',
  },
).withProps(({ ratioRef }) => (
  ratioRef ? ({ f: themeGbl.fontRangeFluid[ratioRef] }) : ({})
));

export const BoxAbs = gl(Box, { propsAreCssOverrides: true })({
  position: 'absolute',
  top: 'inherit',
  left: 'inherit',
  bottom: 'inherit',
  right: 'inherit',
});

export const BoxCenterAbs = gl(Box)({
  position: 'absolute',
  top: '0px',
  left: '0px',
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const BoxFullScreen = gl(Box)({
// position: 'fixed',
// top: '0px',
// left: '0px',
  width: '100vw',
  height: '100vh',
});

export const BoxFullScreenCenter = gl(BoxFullScreen)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const RollOverAbs = gl(BoxAbs, { filterProps: ['opacity'] })(({ color, opacity }) => ({
  top: '0px',
  left: '0px',
  width: '100%',
  height: '100%',
  backgroundColor: color || 'transparent',
  opacity: '0',
  ':hover': {
    opacity: opacity || '0.6',
    cursor: 'pointer',
  },
}));


export const Flex = gl(Box)({
  display: 'flex',
});

export const H2 = Box.withComponent('h2');
export const H1 = Box.withComponent('h1');

//
// TEXT
//

export const Text = gl(Box.withComponent('p'))({
  margin: '0px',
});

export const TextDiv = Text.withComponent('div');

export const TextUpper = gl(Text)({
  textTransform: 'uppercase',
});

export const TextLightUpper = gl(TextUpper)({
  fontWeight: '300',
});

export const TextLight = gl(Text)({
  fontWeight: '300',
});

export const TextMediumUpper = gl(TextUpper)({
  fontWeight: '400',
});

export const TextMediumUpperDiv = TextMediumUpper.withComponent('div');


export const TextMedium = gl(Text)({
  fontWeight: '400',
});

export const TextMediumDiv = TextMedium.withComponent('div');


export const TextLighBoldUpper = gl(TextUpper)({
  fontWeight: '500',
});

export const TextLighBold = gl(Text)({
  fontWeight: '500',
});

export const TextLighBoldDiv = TextLighBold.withComponent('div');


export const TextBoldUpper = gl(TextUpper)({
  fontWeight: '700',
});


export const TextBoldUpperDiv = TextBoldUpper.withComponent('div');

export const TextBold = gl(Text)({
  fontWeight: '700',
});

export const TextBoldDiv = TextBold.withComponent('div');

export const BoxBgImg = gl(Box)(({ src }) => ({
  // Bg Img
  backgroundImage: `url(${src})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'auto  auto',
  backgroundPosition: 'top left',
  backgroundAttachment: 'scroll',
}));

export const BoxBgImgAbs = gl(BoxBgImg)({
  position: 'absolute',
  top: '0px',
  left: '0px',
  width: '100%',
  height: '100%',
});


export const BoxBgImgCenterW = gl(BoxBgImg)({
  backgroundSize: '100%  auto',
  backgroundPosition: 'center center',
});

export const BoxBgImgTopW = gl(BoxBgImg)({
  backgroundSize: '100%  auto',
  backgroundPosition: 'center top',
});


export const BoxBgImgAbsCenterW = gl(BoxBgImgAbs)({
  backgroundSize: '100%  auto',
  backgroundPosition: 'center center',
});

export const BoxBgImgCenterWScrollFixed = gl(BoxBgImgCenterW)({
  backgroundAttachment: 'fixed',
});

export const BoxBgImgCenterCover = gl(BoxBgImg)({
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
});

export const BoxBgImgCenterContain = gl(BoxBgImg)({
  backgroundSize: 'contain',
  backgroundPosition: 'center center',
});

export const BoxBgImgCenterContainAbs = gl(BoxBgImgAbs)({
  backgroundSize: 'contain',
  backgroundPosition: 'center center',
});


export const FlexBgImgImgCenterW = gl(BoxBgImg)({
  display: 'flex',
});

// Box Ratio Width/Height
export const BoxRatioAbs = ({ ratio, children, ...props }) => (
  <Box
    w={1}
    p={0}
    {...props}
    css={{
      position: 'relative',
    }}
  >
    { /* Box with ratio width/height */ }
    <Box
      w={1}
      pt={`${ratio * 100}%`}
    />

    {/* They are set to absolute positioning TODO: to be revised */}
    { children }
  </Box>
);

BoxRatioAbs.propTypes = {
  ratio: PropTypes.number.isRequired,
  children: PropTypes.node,
};

BoxRatioAbs.defaultProps = {
  children: undefined,
};


//
// LINKS
//
export const Link = gl.a({
});

//
// IMAGE
//
export const Img = gl.img({
  width: '100%',
  height: 'auto',
});


export const ImgBottomAbs = gl.img({
  position: 'absolute',
  bottom: '0px',
  left: '0px',
  width: '100%',
  height: 'auto',
});

export const ImgCenterVert = gl.img({
  width: '100%',
  height: 'auto',
  verticalAlign: 'middle',
});

//
// SPACES
//
// See : https://www.smashingmagazine.com/2015/10/space-yourself/

// En space
export const SpaceEn = () => (
  <span>
    <span />
    &#8194;
  </span>
);


//
// CSS
//
export const FullScreenCss = {
  width: '100vw',
  height: '100vh',
};



// WEBPACK FOOTER //
// ./src/index.js